import React from 'react';
import {
  Image,
  Grid,
} from 'semantic-ui-react';

import tuclab from '../img/partners/tuclab.jpg';
import qhub from '../img/partners/qhub.jpg';
import saxeed from '../img/partners/saxeed.jpg';
import vsr from '../img/partners/vsr.jpg';


const PartnersComponent = () => (
    <Grid>
      <Grid.Row only='mobile tablet' style={{margin: '1em 0em'}} columns={2}>
        <Grid.Column verticalAlign='middle'>
            <center>
                <Image as='a' href='https://www.tu-chemnitz.de/transfer/tuclab/' target='_blank' src={tuclab} size='small' />
            </center>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
            <center>
                <Image as='a' href='https://q-hub.de/' target='_blank' src={qhub} size='small' />
            </center>
        </Grid.Column>
        
      </Grid.Row>
      <Grid.Row only='mobile tablet' style={{margin: '1em 0em'}} columns={2}>
        <Grid.Column verticalAlign='middle'>
            <center>
                <Image as='a' href='https://vsr.informatik.tu-chemnitz.de/' target='_blank' src={vsr} size='small' />
            </center>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
            <center>
                <Image as='a' href='https://www.saxeed.net/' target='_blank' src={saxeed} size='small' />
            </center>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row only='computer' style={{margin: '1em 0em'}} columns={4}>
        <Grid.Column verticalAlign='middle'>
            <center>
                <Image as='a' href='https://www.tu-chemnitz.de/transfer/tuclab/' target='_blank' src={tuclab} size='small' />
            </center>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
            <center>
                <Image as='a' href='https://q-hub.de/' target='_blank' src={qhub} size='small' />
            </center>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
            <center>
                <Image as='a' href='https://vsr.informatik.tu-chemnitz.de/' target='_blank' src={vsr} size='small' />
            </center>
        </Grid.Column>
        <Grid.Column verticalAlign='middle'>
            <center>
                <Image as='a' href='https://www.saxeed.net/' target='_blank' src={saxeed} size='small' />
            </center>
        </Grid.Column>
      </Grid.Row>
    </Grid>
)



export default PartnersComponent;


// WEBPACK FOOTER //
// ./src/components/PartnersComponent.js